import { render } from "./Card2.vue?vue&type=template&id=22e8a3e6"
import script from "./Card2.vue?vue&type=script&lang=js"
export * from "./Card2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__